import { Box, Card, Divider, Typography, makeStyles } from "@material-ui/core";
import React, { useState } from "react";

import { ToggleButton } from "@material-ui/lab";
import useStatProducts from "../../../../hooks/useStatProducts";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: 0,
    width: "100%",
    display: "flex",
  },
  card: {
    width: 357,
    height: 223,
    boxShadow: "0px 10px 0px -7px rgba(0,0,0,0)",
    marginTop: 6,
    borderRadius: 8,
  },
  avatar: { height: 30, width: 30 },
  rightToggleButton: {
    width: "100%",
    height: 38,
    borderTopRightRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    overflow: "hidden",
    "&$selected": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  leftToggleButton: {
    width: "100%",
    height: 38,
    borderTopLeftRadius: 8,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    overflow: "hidden",
    "&$selected": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  selected: {},
  textOrderStyle: { margin: "5px 10px 0px 5px", fontSize: 14 },
  textNameStyle: { marginLeft: 0, marginTop: 5, fontSize: 14 },
  textAmountStyle: { marginTop: 5, marginRight: 10, fontSize: 14 },
  textHeaderStyle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.blue,
  },
}));

function Top5ProductsComponent({ periodType, fromDate, toDate }) {
  const classes = useStyles();
  const translate = useTranslate();
  const [toggleButtonValue, setToggleButtonValue] = useState("member");
  const handleToggleButton = (newValue) => {
    if (toggleButtonValue === newValue) {
      setToggleButtonValue(toggleButtonValue);
    } else {
      setToggleButtonValue(newValue);
    }
  };
  const { products, loading, error } = useStatProducts(
    toggleButtonValue,
    periodType,
    fromDate,
    toDate
  );
  if (loading) return null;
  if (error) return null;

  let summedProducts = [];
  products?.forEach((element) => {
    if (!element || !element.name) {
      return;
    } else {
      const existingProductIndex = summedProducts.findIndex(
        (s) => s.id === element.product_id
      );
      if (existingProductIndex === -1) {
        summedProducts.push({
          id: element.product_id,
          name: element.name,
          totalQty: element.life_time[toggleButtonValue].total_qty,
        });
      } else {
        summedProducts[existingProductIndex].totalQty +=
          element.life_time[toggleButtonValue].total_qty;
      }
    }
  });
  let sortedTop5Products = summedProducts
    .sort((a, b) => {
      if (a.name > b.name) return 1;
      if (b.name > a.name) return -1;
      return 0;
    })
    .sort((a, b) => b.totalQty - a.totalQty);
  sortedTop5Products = sortedTop5Products.filter((a) => a.totalQty !== 0);
  if (sortedTop5Products.length === 0) {
    for (let i = 0; i < 5; i++)
      sortedTop5Products.push({
        id: i,
        name: "-",
        totalQty: 0,
      });
  }

  return (
    <Box style={{ marginTop: 12 }}>
      <Typography className={classes.textHeaderStyle}>
        {translate("ra.text.bi.Top5Products")}
      </Typography>
      <Card className={classes.card}>
        <Box className={classes.container}>
          <ToggleButton
            value="member"
            onClick={(_, newValue) => {
              handleToggleButton(newValue);
            }}
            selected={toggleButtonValue === "member"}
            classes={{
              root: classes.leftToggleButton,
              selected: classes.selected,
            }}
          >
            {translate("ra.text.bi.members")}
          </ToggleButton>

          <ToggleButton
            value="guest"
            onClick={(_, newValue) => {
              handleToggleButton(newValue);
            }}
            selected={toggleButtonValue === "guest"}
            classes={{
              root: classes.rightToggleButton,
              selected: classes.selected,
            }}
          >
            {translate("ra.text.bi.walkIn")}
          </ToggleButton>
        </Box>
        {toggleButtonValue === "member" ? (
          <Box>
            {sortedTop5Products.map((top5ProductsMember, index) => {
              if (index > 4) return null;
              return (
                <Box
                  key={"ind" + index}
                  margin="0 0 0 0"
                  style={{ height: 37 }}
                >
                  <Box
                    display="grid"
                    gridTemplateColumns="235px 100px"
                    height="100%"
                    paddingLeft="11px"
                    paddingRight="11px"
                    boxSizing="border-box"
                    alignItems="center"
                    width="100%"
                  >
                    <Box display="flex">
                      <Typography className={classes.textOrderStyle}>
                        {index + 1}
                      </Typography>

                      <Typography className={classes.textNameStyle} noWrap>
                        {top5ProductsMember.name}
                      </Typography>
                    </Box>
                    <Box display="flex" justifySelf="end">
                      <Typography
                        align="center"
                        className={classes.textAmountStyle}
                      >
                        {`${top5ProductsMember.totalQty.toLocaleString()} units `}
                      </Typography>
                    </Box>
                  </Box>
                  <Box height={2} />
                  {index === sortedTop5Products.length - 1 ? null : <Divider />}
                </Box>
              );
            })}
          </Box>
        ) : (
          <Box>
            {sortedTop5Products.map((top5ProductsWalkIn, index) => {
              if (index > 4) return null;
              return (
                <Box margin="0 0 0 0" style={{ height: 37 }} key={"ws" + index}>
                  <Box
                    display="grid"
                    gridTemplateColumns="235px 100px"
                    // justifyContent="space-between"
                    height="100%"
                    marginLeft="11px"
                    alignItems="center"
                  >
                    <Box display="flex">
                      <Typography className={classes.textOrderStyle}>
                        {index + 1}
                      </Typography>

                      <Typography className={classes.textNameStyle}>
                        {top5ProductsWalkIn.name}
                      </Typography>
                    </Box>
                    <Box display="flex" justifySelf="end">
                      <Typography
                        align="center"
                        className={classes.textAmountStyle}
                      >
                        {`${top5ProductsWalkIn.totalQty.toLocaleString()} units `}
                      </Typography>
                    </Box>
                  </Box>
                  <Box height={2} />
                  {index === sortedTop5Products.length - 1 ? (
                    <Box />
                  ) : (
                    <Divider />
                  )}
                </Box>
              );
            })}
          </Box>
        )}
      </Card>
    </Box>
  );
}

export default Top5ProductsComponent;
